<div class="modal-header">
  <h4 class="modal-title">{{ modalTitle }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <div class="item-filter m-b-20 m-x-10">
    <div class="filter-input no-max-width">
      <input
        #searchInput
        type="text"
        [(ngModel)]="query"
        (keyup)="filter()"
        (keyup.enter)="search()"
        (focus)="focused = true"
        (blur)="focused = false"
        [placeholder]="searchPlaceholder"
        [disabled]="type == 'videos' && !contentService.videos"
      />
      <div class="extras d-flex align-items-center">
        @if (query) {
          <div class="clear" (click)="clear()"><fa-icon icon="times"></fa-icon></div>
        }
        <!-- Only once there's something to search: empty, it took a third of the field on a
             phone and cut the placeholder off. Enter searches either way. -->
        @if (type == "articles" && query) {
          <div class="search-btn" [class.active]="query" tabindex="0" (keyup.enter)="search()" (click)="search()">{{ "sphere.search" | translate }}</div>
        }
      </div>
      @if (focused && query && type == "articles") {
        <div class="text-muted t-12" style="position: absolute; bottom: -20px; left: 0px">{{ "search.hit_enter_to_search" | translate }}</div>
      }
    </div>
  </div>
  <myp-inline-loader [loading]="searching || (type == 'videos' && !contentService.videos)" height="100px" spinnerName="registeringProductLoader"></myp-inline-loader>
  @if (type == "articles" && searchResults && searchResults.length) {
    @for (article of searchResults; track article) {
      <myp-list-item [subData]="article.subData" [title]="article.name" [showImage]="false" (itemClicked)="selectContent(article)"></myp-list-item>
    }
  }
  @if (type == "videos" && displayedVideos && displayedVideos.length) {
    <div class="grid-container wider pad-10">
      @for (item of displayedVideos; track item) {
        <myp-video-grid-item [selectable]="true" [video]="item" [showBorder]="true" (videoClickedEvent)="selectContent(item)"></myp-video-grid-item>
      }
    </div>
  }
  @if (type == "videos" && displayedVideos && !displayedVideos.length) {
    <div class="text-center m-y-50">{{ "search.no_videos_match_search" | translate }}</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
